export default __webpack_public_path__ + "static/media/lottery.096bc9e1.svg";